export interface UnCommitPlanRequest {
    planId?: string;
}
